<template>
  <div>
    <el-dialog
      title="设置工资卡"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      @close="dividendAgreementVisibleClose"
    >
      <div style="text-align: right">
        <el-button
          size="small"
          type="primary"
          plain
          @click="addAccount"
          icon="el-icon-plus"
          >新增</el-button
        >
      </div>

      <MyTable
        :tableData="tableData"
        :tableConfig="tableConfig"
        :height="tableHeight"
        :indexFlag="true"
        tableEmptyText="暂无数据，点击新增"
        @EmptyBtn="addAccount"
      >
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:isDefault="slotData">
          {{ slotData.scope.row.isDefault ? "是" : "否" }}
        </template>
        <template v-slot:isOpenInPlatform="slotData">
          {{ slotData.scope.row.isOpenInPlatform ? "是" : "否" }}
        </template>
        <template v-slot:isLogout="slotData">
          <el-tag
            v-if="slotData.scope.row.isLogout == true"
            type="info"
            size="mini"
          >
            注销</el-tag
          >
          <el-tag v-else type="success" size="mini"> 正常</el-tag>
        </template>
        <template v-slot:imgPath="slotData">
          <el-image
            v-if="slotData.scope.row.imgPath"
            style="width: 100px; height: 70px"
            :src="slotData.scope.row.imgPath"
            fit="fill"
            :preview-src-list="[slotData.scope.row.imgPath]"
          ></el-image>
        </template>
        <template v-slot:operation="slotData">
          <el-button
            @click="setDefault(slotData.scope.row)"
            class="chabtn"
            size="small"
            icon="el-icon-edit"
            v-if="!slotData.scope.row.isLogout"
            >设为工资卡</el-button
          >
          <el-button
            @click="deleteCustomer(slotData.scope.row)"
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            v-if="!slotData.scope.row.isOpenInPlatform"
            v-show="!slotData.scope.row.isLogout"
            >注销</el-button
          >
        </template>
      </MyTable>

      <Pagination
        style="margin-top: 10px"
        :total="total"
        @getNewData="getTalentList"
        ref="pagination"
      />
    </el-dialog>
    <el-dialog
      title="新增银行卡"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="660px"
      @close="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" v-enterToNext="true">
        <div style="display: flex; justify-content: space-between">
          <div style="width: 48%">
            <el-form-item label="银行卡号" prop="cardNum">
              <el-input
                v-model="form.cardNum"
                maxlength="19"
                @input="cardInput"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="openingBank">
              <el-select
                filterable
                v-model="form.openingBank"
                style="width: 100%"
                placeholder="请选择开户银行"
                ref="batchSelect"
              >
                <el-option
                  v-for="item in BankList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
              <!-- <el-input v-model="form.openingBank"></el-input> -->
            </el-form-item>

            <el-form-item label="开户姓名" prop="openingBankName">
              <el-input v-model="form.openingBankName" disabled></el-input>
            </el-form-item>
          </div>
          <div
            style="
              width: 48%;
              border-left: 1px solid #e4e7ed;
              padding-left: 20px;
            "
          >
            <el-col :span="24" class="imgPath">
              <el-form-item
                label="银行卡照片"
                prop="identityCardFrontPath"
                style="width: 100%"
              >
                <el-upload
                  :class="{ 'hide-upload': isHideimgPathUpload }"
                  action=""
                  :limit="1"
                  accept=".jpg,.png"
                  :file-list="form.imgPath"
                  list-type="picture-card"
                  :on-preview="onPreview"
                  :before-remove="removeUploadimgPath"
                  ref="uploadimgPath"
                  :http-request="uploadimgPath"
                >
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    请上传.jpg/.png格式文件，文件大小不超过10M
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </div>
        </div>
      </el-form>
      <div style="color: #e6a23c">
        请仔细核对银行卡信息，避免财务往来，或工资发放产生错误！由于此信息出现的资金支付或收款错误，本系统将不承担任何责任。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              resetForm();
              addDialogVisible = false;
            }
          "
          >关 闭</el-button
        >
        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="imgEdit('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";

export default {
  props: {
    visible: Boolean,
    row: null,
  },
  components: {
    MyTable,
  },
  data() {
    let validatecardNum = (rule, value, callback) => {
      var BIN = require("bankcardinfo");
      BIN.getBankBin(value, (err, data) => {
        if (!err) {
          this.bankName = data.bankName;
          callback();
        } else {
          this.bankName = "";
          callback(new Error("银行卡号不正确"));
        }
      });
    };
    return {
      bankName: "",
      BankList: [],
      addDialogVisible: false,
      dialogVisible: false,
      form: {
        identityCardBackPath: [],
        logo: [],
        identityCardFrontPath: [],
        electronicProtocol: [],
        imgPath: [],
      },
      tableData: [],
      tableConfig: [
        {
          field: "openingBank",
          label: "开户银行",
          align: "center",
          minWidth: 120,
          flag: true,
        },

        {
          field: "cardNum",
          label: "银行卡号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "openingBankName",
          label: "开户姓名",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        {
          field: "isLogout",
          label: "状态",
          slotName: "isLogout",
          align: "center",
          minWidth: 90,
          flag: true,
        },
        {
          field: "tel",
          label: "平台开卡",
          slotName: "isOpenInPlatform",
          align: "center",
          width: 90,
          flag: true,
        },
        {
          field: "isDefault",
          label: "默认卡",
          align: "center",
          slotName: "isDefault",
          width: 180,
          flag: true,
        },
        {
          field: "imgPath",
          label: "银行卡照片",
          align: "center",
          slotName: "imgPath",
          width: 180,
          flag: true,
        },
        {
          field: "createUserName",
          label: "写入操作人",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "createDate",
          label: "写入时间",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "logoutUserName",
          label: "注销操作人",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          field: "updateDate",
          label: "注销时间",
          align: "center",

          width: 180,
          flag: true,
        },
        {
          label: "操作",
          slotName: "operation",
          width: 240,
          fixed: "right",
          align: "right",
          flag: true,
        },
      ],
      loading: false,
      tableHeight: "400px",
      total: 0,
      rules: {
        cardNum: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
          { validator: validatecardNum, trigger: ["blur"] },
        ],
        openingBankName: [
          { required: true, message: "请输入开户姓名", trigger: "blur" },
        ],
        openingBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        userType: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["change", "blur"],
          },
        ],
        createDate: [
          { required: true, message: "请选择注册时间", trigger: "blur" },
        ],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],

        isInsder: [
          {
            required: true,
            message: "请选择是否为公司人员",
            trigger: ["change", "blur"],
          },
        ],
        isStore: [
          {
            required: true,
            message: "请选择是否有门店",
            trigger: ["change", "blur"],
          },
        ],
      },
      submitLoading: false,
    };
  },
  computed: {
    isHideLogoUpload: function () {
      return this.form.logo.length == 1;
    },
    isHideIdCardFrontUpload: function () {
      return this.form.identityCardFrontPath.length == 1;
    },
    isHideIdCardBackUpload: function () {
      return this.form.identityCardBackPath.length == 1;
    },
    isHideimgPathUpload: function () {
      return this.form.imgPath.length == 1;
    },
  },
  methods: {
    cardInput() {
      this.$set(this.form, "cardNum", this.form.cardNum.replace(/[^\d]/g, ""));
    },
    imgEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (this.bankName && this.bankName != this.form.openingBank) {
          this.$confirm(
            `您填写的银行卡${"(" + this.bankName + ")"}与您选择的开户银行${
              "(" + this.form.openingBank + ")"
            }不匹配，是否确认?`,
            "提示",
            {
              confirmButtonText: "确 定",
              cancelButtonText: "取 消",
              type: "warning",
            }
          )
            .then(() => {
              this.addCar();
            })
            .catch(() => {});
        } else {
          this.addCar();
        }
      });
    },
    //请求新增
    addCar() {
      this.submitLoading = true;
      let sendData = {
        userId: this.row.userId,
        cardNum: this.form.cardNum,
        openingBank: this.form.openingBank,
        openingBankName: this.form.openingBankName,
        imgPath: this.form.imgPath[0]?.url || "",
      };
      this.$api.user.UserCardEdit(sendData).then((res) => {
        if (res.error === false) {
          this.addDialogVisible = false;
          this.getTalentList();
          this.bankName = "";

          this.$message.success("新增成功");
        } else {
          this.$message.error(res.msg);
        }
        this.submitLoading = false;
      });
    },
    setDefault(row) {
      let sendData = {
        id: this.row.id,
        bankNo: row.cardNum,
        bankName: row.openingBank,
      };

      this.$api.user.UpdateDefaultBankInfo(sendData).then((res) => {
        if (res.error === false) {
          // this.$set(this.form, "defaultBankName", row.openingBank);
          // this.$set(this.form, "defaultBankNo", row.cardNum);
          this.$message.success("设置成功");
          this.getTalentList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deleteCustomer(row) {
      this.$confirm("是否注销？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // let sendData = {
          //   id: row.id,
          // };
          this.submitLoading = true;
          let sendData = new FormData();
          sendData.append("userCardId", row.id);
          this.$api.user.Logout(sendData).then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.getTalentList();
              this.$message.success("注销成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    dividendAgreementVisibleClose() {
      this.$emit("colseDrawer");
    },
    uploadSingleImage(fileObj, imgType) {
      this.loading = true;
      // const formData = new FormData();
      // formData.append("file", fileObj.file);
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          this.loading = false;

          this.submitLoading = false;

          if (res.code === 0) {
            this.form[imgType].push({
              name: fileObj.file.name,
              url: res.data[0],
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form[imgType] = [];
          }
        });
    },
    uploadimgPath(fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadimgPath.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }
      this.uploadSingleImage(fileObj, "imgPath");
    },
    removeUploadimgPath() {
      this.form.imgPath = [];
    },
    resetForm() {
      this.form = {
        identityCardBackPath: [],
        logo: [],
        identityCardFrontPath: [],
        electronicProtocol: [],
        imgPath: [],
      };
    },
    onPreview(file) {
      console.log("dfsfd========s", file);
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    //获取银行列表
    getBankList() {
      this.$api.manage.BankList().then((res) => {
        if (res.error === false) {
          this.BankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取分页
    getTalentList() {
      this.loading = true;
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          userId: this.row.userId,
        };

        this.$api.user.UserCardPage(sendData).then((res) => {
          this.loading = false;
          if (!res.error) {
            console.log(res);
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    addAccount() {
      this.addDialogVisible = true;
      this.$set(this.form, "openingBankName", this.row.cname);
      // this.form.openingBankName = this.form.cname;
    },
  },
  watch: {
    visible(val) {
      console.log(val);
      if (val) {
        console.log(this.row.cname);
        this.getBankList();
        this.dialogVisible = val;
        this.getTalentList();
      }
    },
  },
};
</script>

<style lang="less" >
</style>